import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
import { CountdownClock } from './CountdownClock';
const reassurances = ['El pago es único · Sin suscripción', '100% PDF · enviado a tu email', 'Garantía de satisfacción de 7 días'];
export function FinalSection() {
  return <section className="bg-ink text-cream" data-id="element-76" data-mp="334a4ke2zkaxp">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-77" data-mp="2ochzcuwwod9p">
        <div className="grid gap-14 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-78" data-mp="2t49gkeu696n6">
          <div data-id="element-79" data-mp="2t5klwj39mmge">
            <Eyebrow tone="light" data-id="element-80" data-mp="2t64480wtvcuy">Cuenta final</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-81" data-mp="2fe5y7yyexx30">
              Pack completo, precio de esta noche
            </h2>
            <div className="mt-8" data-id="element-82" data-mp="25eyormusuml6">
              <CountdownClock variant="light" data-id="element-83" data-mp="25fzx3jkfkuz7" />
            </div>
          </div>

          <div className="rounded-2xl border border-cream/15 bg-cream/[0.04] p-8 sm:p-10" data-id="element-84" data-mp="2ae1hq8xi92cs">
            <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-cream/60" data-id="element-85" data-mp="2wdlhedojspoi">
              6 volúmenes + 6 bonos gratis
            </p>
            <div className="mt-4 flex flex-wrap items-baseline gap-4" data-id="element-86" data-mp="2rh4jirrjqwy8">
              <span className="font-display text-5xl font-semibold leading-none sm:text-6xl" data-id="element-87" data-mp="35di5oe70zmj1">
                $27.990
              </span>
              <span className="font-display text-2xl text-cream/45 line-through" data-id="element-88" data-mp="30dvro2jdi296">$745.000</span>
            </div>
            <p className="mt-3 text-[15px] text-cream/75" data-id="element-89" data-mp="28oskof03qdsu">Ahorrás $717.010 hoy</p>

            <div className="mt-8" data-id="element-90" data-mp="28mpm36kvvcci">
              <CtaButton data-id="element-91" data-mp="2mg73olu0eezw">¡Sí, quiero ahorrar tiempo y retener más alumnos!</CtaButton>
            </div>

            <ul className="mt-7 space-y-2.5" data-id="element-92" data-mp="2hoyrxj57ihjk">
              {reassurances.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] text-cream/70" data-id="element-93" data-mp="1tyurtlr88zxb">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-accent" data-id="element-94" data-mp="1p12xkl3411py" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-20 border-t border-cream/15 pt-14" data-id="element-95" data-mp="3u141t9e5x2g9">
          <div className="max-w-3xl" data-id="element-96" data-mp="2n81qva1ym8s">
            <Eyebrow tone="light" data-id="element-97" data-mp="2o9dl1yw7crk">Para cerrar</Eyebrow>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-tight sm:text-5xl" data-id="element-98" data-mp="2pkkvbrjr2nf">
              El reloj corre.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-cream/75" data-id="element-99" data-mp="364yo0z1lj6mi">
              Mañana podés volver a pasar horas buscando fichas… o podés tener todo tu año de
              material listo en los próximos 60 segundos.
            </p>
            <p className="mt-4 text-base leading-relaxed text-cream/75" data-id="element-100" data-mp="3g47f9k52u756">
              Pasaste años dominando tu instrumento. Merecés un sistema de enseñanza a la altura de
              tu música.
            </p>
            <p className="mt-8 font-display text-2xl italic leading-snug text-cream sm:text-3xl" data-id="element-101" data-mp="ve8b7lr5ki7u">
              Basta de la corrida del domingo. Empezá con el sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
}